<template>
  <div>
    <nav class="navbar navbar-expand-lg">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">{{ translate('dashboard') }}</a>
        <button
          type="button"
          class="navbar-toggler navbar-toggler-right"
          :class="{ toggled: $sidebar.showSidebar }"
          aria-controls="navigation-index"
          aria-expanded="false"
          aria-label="Toggle navigation"
          @click="toggleSidebar"
        >
          <span class="navbar-toggler-bar burger-lines"></span>
          <span class="navbar-toggler-bar burger-lines"></span>
          <span class="navbar-toggler-bar burger-lines"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end">
          <ul class="nav navbar-nav mr-auto"></ul>
          <ul class="navbar-nav ml-auto">
            <div v-if="!isSystemUser">
            <base-dropdown tag="li" no-auto-close>
            <template #title >
                <b-icon icon="bell-fill" aria-hidden="true"></b-icon>
                {{ translate('unpaidList') }}
                <b class="caret"></b>
                <span class="notification" >{{ totalNotifications}}</span>
              </template>
              <!-- Notification Items -->
              <div
                v-for="(notification, index) in ekubNotification"
                :key="index"
                class="dropdown-item"
                style="border-bottom: 3px solid rgba(240, 206, 13, 0.937);"
                @click.stop
              >
                <div class="row">
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="people-fill"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.memberFullName }}
                    </h6>
                  </div>
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="telephone-fill"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.memberPhoneNumber }}
                    </h6>
                  </div>
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="tags-fill"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.ekubType }}
                    </h6>
                  </div>
                  <div class="col-md-12">
                    <h6 style="color:rgb(37, 91, 48)">
                      <b-icon
                        style="color: rgba(240, 206, 13, 0.937)"
                        icon="currency-dollar"
                        aria-hidden="true"
                      ></b-icon>
                      {{ notification.amountPerCycle }}
                    </h6>
                  </div>
                </div>
              </div>

              <!-- Pagination Controls -->
              <div class="pagination-container">
                <button
                  class="btn btn-sm btn-primary"
                  @click.stop="fetchPreviousPage"
                  :disabled="currentPage === 0"
                >
                  <
                </button>
                <span class="mx-2">Page {{ currentPage+1 }} of {{ totalPages }}</span>
                <button
                  class="btn btn-sm btn-primary"
                  @click.stop="fetchNextPage"
                  :disabled="currentPage === totalPages"
                >
                  >
                </button>
              </div>
            </base-dropdown>
          </div>
            <li class="nav-item">
              <a @click="ViewAccount" class="nav-link">
                {{ translate('account') }}
              </a>
            </li>
            <li class="nav-item">
              <a @click="signOut" class="nav-link">
                {{ translate('logout') }}
              </a>
            </li>
            <li class="nav-item">
            <select  @change="changeLanguage($event.target.value)" 
              class="nav-link" 
              style="border: none;" 
              :value="currentLanguage">
              <option value="en">English</option>
              <option value="am">Amharic (አማርኛ)</option>
              <option value="oro">Afaan Oromoo</option>
              <option value="tg">Tigrinya (ትግርኛ)</option>
              <!-- <option value="am">French (Français)</option> -->
            </select>
          </li>
          </ul>
        </div>
      </div>
    </nav>

    <!-- Account Modal -->
    <b-modal
      id="modal-center-account"
      hide-footer
      :title="translate('account')"
      content-class="shadow"
    >
      <template #modal-header="{ close }">
        <h5>{{ translate('account') }}</h5>
        <p class="h5 mb-2">
          <b-icon
            icon="x-square"
            class="close-icon"
            @click="
              close();
              clearData();
            "
          ></b-icon>
        </p>
      </template>
      <b-row no-gutters>
        <b-col md="12" class="profile-icon">
          <b-icon icon="person-bounding-box"></b-icon>
        </b-col>
      </b-row>
      <b-row no-gutters class="mt-2">
        <b-col xs="6" class="left-profile">
          <b-row class="left-prof">{{ translate('firstName') }}</b-row>
          <b-row class="left-prof">{{ translate('lastName') }}</b-row>
          <b-row class="left-prof">{{ translate('username') }}</b-row>
          <b-row class="left-prof">{{ translate('phoneNumber') }}</b-row>
          <b-row class="left-prof">{{ translate('email') }}</b-row>
        </b-col>
        <b-col xs="4" class="right-profile">
          <b-row class="right-prof">{{ accountData.firstName }}</b-row>
          <b-row class="right-prof">{{ accountData.lastName }}</b-row>
          <b-row class="right-prof">{{ accountData.username }}</b-row>
          <b-row class="right-prof">{{ accountData.phoneNumber }}</b-row>
          <b-row class="right-prof">{{ accountData.email }}</b-row>
        </b-col>
      </b-row>
      <b-row no-gutters class="mt-2 changePWD">
        <b-button @click="changePassword()" class="btn-outline-primary" size="sm" style="font-weight: 700;">
          {{ translate('changePassword') }}
        </b-button>
      </b-row>
    </b-modal>

    <!-- Change Password Modal -->
    <b-modal
    id="modal-center-changePwd"
    hide-footer
    :title="translate('changePassword')"
    content-class="shadow"
  >
    <template #modal-header="{ close }">
      <h5>{{ translate('changePassword') }}</h5>
      <p class="h5 mb-2">
        <b-icon
          icon="x-square"
          class="close-icon"
          @click="() => { close(); clearData(); }"
        ></b-icon>
      </p>
    </template>
    <b-form @submit.prevent="submitChangeForm">
      <b-row no-gutters>
        <b-col md="12">
          <b-form-group
            label="Old Password"
            :state="isOldPasswordValid !== null ? isOldPasswordValid : null"
            invalid-feedback="Old password is required"
          >
            <b-form-input
              type="password"
              v-model="addData.oldPassword"
              @input="validateOldPassword"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="New Password"
            :state="isNewPasswordValid !== null ? isNewPasswordValid : null"
            invalid-feedback="Password must be at least 8 characters long and contain upper, lower, and number"
          >
            <b-form-input
              type="password"
              v-model="addData.newPassword"
              @input="validateNewPassword"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            label="Confirm Password"
            :state="isConfirmPasswordValid !== null ? isConfirmPasswordValid : null"
            invalid-feedback="Passwords do not match"
          >
            <b-form-input
              type="password"
              v-model="addData.confirmPassword"
              @input="validateConfirmPassword"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="mt-2">
          <b-button type="submit" variant="primary" :disabled="!isNewPasswordValid">Submit</b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
  </div>
</template>
<script>
import Vinput from 'src/components/Inputs/Vinput.vue'
import { setLanguage, translate } from 'src/i18n.js';
  export default {
    components: {
      Vinput
    },
    data () {
      return {
        currentLanguage:localStorage.getItem('lang')||'en',
        activeNotifications: false,
        ekubNotification: [],
        accountData:{
          firstName: "",
          lastName: "",
          userName: "",
          email: "",
          phonenumber: "",
          accountNumber: ""
        },
        addData: {
          userId: sessionStorage.getItem("userID"),
          newPassword: "",
          oldPassword: "",
          confirmPassword: ""
        }
      }
    },
    computed: {
      isSystemUser() {
      const userRole = sessionStorage.getItem('user_role');
      return userRole === 'SYSTEM_ADMIN' || userRole === 'SYSTEM_MANAGER';
    }
  },
    mounted(){
      //this.getTenantsWithPaymentStatus();
      this.ViewNotification(sessionStorage.getItem("ID"), 1);
    },
    methods: {

      validateOldPassword() {
      this.isOldPasswordValid = this.addData.oldPassword.length > 0;
    },
    validateNewPassword() {
      const { newPassword } = this.addData;
      this.isNewPasswordValid =
        newPassword.length >= 8 &&
        /[a-z]/.test(newPassword) &&
        /[A-Z]/.test(newPassword) &&
        /\d/.test(newPassword);
    },
    validateConfirmPassword() {
      this.isConfirmPasswordValid = this.addData.confirmPassword === this.addData.newPassword;
    },
    submitChangeForm() {
      this.validateOldPassword();
      this.validateNewPassword();
      this.validateConfirmPassword();

      if (this.isOldPasswordValid && this.isNewPasswordValid && this.isConfirmPasswordValid) {
        // Handle the form submission logic (e.g., API call)
        console.log('Form submitted:', this.addData);
        // Reset form data after submission
        this.clearData();
      } else {
        console.log('Form contains errors. Please fix them.');
      }
    },
      translate,
      
    changeLanguage(lang) {
      this.currentLanguage = lang; // Update the currentLanguage variable
      localStorage.setItem('lang', lang); // Persist the selected language in local storage
      
      setLanguage(lang);
      this.$forceUpdate();
      window.location.reload();
    },
    fetchPreviousPage() {
  if (this.currentPage > 0) {
    this.currentPage--;  // Decrement the page
    this.ViewNotification(sessionStorage.getItem("ID"), this.currentPage+1);  // Pass the updated page
  }
},

fetchNextPage() {
  if (this.currentPage < this.totalPages-1) {
    this.currentPage++;  // Increment the page
    this.ViewNotification(sessionStorage.getItem("ID"), this.currentPage+1);  // Pass the updated page
  }
},
      signOut(){
        // Clear all session storage
        // sessionStorage.clear();
        // Clear local storage (if used)
        // localStorage.clear();
          this.$store.dispatch('Logout')
          .then(()=>{
              this.$router.push('/');
          })
          .catch(error =>{
              //console.log(error);
          });
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      ViewAccount(){
        this.$store.dispatch('getAccountByID', {id: sessionStorage.getItem("userID")})
          .then(response=>{
            this.accountData.firstName = response.data.firstName;
            this.accountData.lastName = response.data.lastName;
            this.accountData.username = response.data.username;
            this.accountData.phoneNumber = response.data.phoneNumber;
            this.accountData.email = response.data.email;
            this.$bvModal.show('modal-center-account');
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
      },
      ViewNotification(ID, page = 1) {
  const userRole = sessionStorage.getItem("user_role");
  let apiCall = "";
  if (["SUPER_ADMIN", "SUPER_MANAGER", "SUPER_FINANCE", "SUPER_USER"].includes(userRole)) {
    apiCall = "getOverdueEkubUnpaidNotification";
  } else if (["ADMIN", "MANAGER", "FINANCE", "USER"].includes(userRole)) {
    apiCall = "getOverdueEkubUnpaidNotificationForUser";
  }

  this.$store
    .dispatch(apiCall, {
      userId: sessionStorage.getItem("ID"),
      superUserId: parseInt(sessionStorage.getItem("superID")),
      page: page, // Pass the current page to the API
    })
    .then((response) => {
      const { notification, currentPage, totalPages, totalItems } = response.data;
      this.ekubNotification = notification;
      this.currentPage = currentPage;
      this.totalPages = totalPages;
      this.totalNotifications = totalItems;
    })
    .catch((error) => {
      this.$notifications.notify({
        message: error.response.data,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "danger",
      });
    });
},

    fetchNotifications(page) {
      this.ViewNotification(sessionStorage.getItem("ID"), page);
    },
      changePassword(){
        this.$bvModal.show('modal-center-changePwd');
      },
      checkPasswordComplexity(password){
        let validationRegex = [
            { regex: /.{6,}/ }, // min 8 letters,
            { regex: /[0-9]/ }, // numbers from 0 - 9
            { regex: /[a-z]/ }, // letters from a - z (lowercase)
            { regex: /[A-Z]/}, // letters from A-Z (uppercase),
            { regex: /[^A-Za-z0-9]/} // special characters
        ]

        var checkValid =  true;
        validationRegex.forEach((item, i) => {
          var isValid = item.regex.test(password);
          checkValid = isValid
          return
        }); 
        return checkValid;
      },
      submitChangeForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change your password?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              if(this.addData.newPassword === this.addData.confirmPassword){
                //console.log("password", this.addData.newPassword, this.checkPasswordComplexity(this.addData.newPassword));
                if(this.checkPasswordComplexity(this.addData.newPassword)){
                  this.$store.dispatch('changePassword', this.addData)
                  .then(response=>{
                      this.$notifications.notify(
                        {
                          message: `<span>Password successfully changed.</span>`,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success'
                        })
                        this.$bvModal.hide('modal-center-changePwd');
                        this.$bvModal.hide('modal-center-account');
                        this.clearData();
                  })
                  .catch(error=>{
                      //console.log(error);
                      this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                  })
                }else{
                  this.$notifications.notify(
                  {
                    message: `<span>Not valid password.</span>`,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                }
              }else{
                this.$notifications.notify(
                {
                  message: `<span>Password did not match.</span>`,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              }
            }
        })
        .catch(error=>{
            //console.log(error)
        })
      }
    }
  }

</script>
<style scoped>
.nav-item{
  cursor: pointer;
}
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.profile-icon{
  font-size: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(240, 206, 13, 0.937);
  margin-right: 40px;
}
.left-profile{
  text-align: right;
  color: rgb(37, 91, 48);
}
.right-profile{
  border-left: 2px solid rgba(240, 206, 13, 0.937);
  padding-left: 40px;
}
.left-prof{
  justify-content: right;
  text-align: right !important;
  margin-right: 20px;
}
.right-prof{
  justify-content: left;
  text-align: left !important;
  margin-right: 5px;
}
@media (min-width: 768px) {
  .profile-icon{
    padding-right: 40px;
  }
}
.changePWD{
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (min-width: 768px) {
  .changePWD{
    padding-right: 40px;
  }
}
</style>
